import type { AdminAnnouncementEmailTemplateDefinition } from "./types";
import {
    formatListBlock,
    joinBlocks,
    splitLines,
} from "./utils";

export const accountUpdateTemplate: AdminAnnouncementEmailTemplateDefinition = {
    key: "ACCOUNT_UPDATE",
    label: "Account Update",
    description:
        "Useful for review outcomes, account changes, or updates that require user follow-through.",
    recommendedAnnouncementType: "GENERAL",
    messageLabel: "Update Summary *",
    messagePlaceholder:
        "Explain the account update, what changed, and any context the user should know.",
    previewEyebrow: "Account Update",
    previewHeaderClassName:
        "bg-[linear-gradient(135deg,#7c3aed_0%,#8b5cf6_45%,#312e81_100%)]",
    previewBadgeClassName:
        "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300",
    fields: [
        {
            id: "accountStatus",
            label: "Account Status",
            type: "text",
            placeholder: "Reviewed and approved",
        },
        {
            id: "nextSteps",
            label: "Next Steps",
            type: "textarea",
            placeholder: "One step per line",
            rows: 4,
        },
        {
            id: "supportContact",
            label: "Support Contact",
            type: "text",
            placeholder: "support@ride2five.com",
        },
    ],
    buildBody: ({ message, fields }) =>
        joinBlocks([
            fields.accountStatus?.trim()
                ? `Your account update: ${fields.accountStatus.trim()}.`
                : null,
            message,
            fields.nextSteps
                ? formatListBlock("Next steps", fields.nextSteps)
                : null,
            fields.supportContact?.trim()
                ? `Support contact: ${fields.supportContact.trim()}`
                : null,
        ]),
    buildPreviewSections: ({ message, fields }) => [
        ...(fields.accountStatus?.trim()
            ? [
                  {
                      label: "Status",
                      body: fields.accountStatus.trim(),
                      tone: "accent" as const,
                  },
              ]
            : []),
        {
            label: "Update",
            body: message,
            tone: "default",
        },
        ...(splitLines(fields.nextSteps || "").length > 0
            ? [
                  {
                      label: "Next Steps",
                      body: splitLines(fields.nextSteps || "").join("\n"),
                      tone: "muted" as const,
                      list: true,
                  },
              ]
            : []),
        ...(fields.supportContact?.trim()
            ? [
                  {
                      label: "Support Contact",
                      body: fields.supportContact.trim(),
                      tone: "muted" as const,
                  },
              ]
            : []),
    ],
};
